import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";
import { Row, Col } from "react-bootstrap"

const ShowcaseGrid = data => {
  // console.log(data)

  // Gracefully handle unknown types
  let type
  try {
    type = data.props.relationships.field_content_type.info
  } catch (e) {}

  let entries
  switch (type) {
    case "Service (Feed)":
      entries = data.data.allNodeService.edges
      break
    default:
      entries = null
  }
  // console.log(entries)

  return (
    <div style={{ margin: "-50px -15px" }}>
      {entries.map((entry, key) => {
        // console.log(entry.node)
        return (
          <Row key={key} noGutters={true}>
            <Col
              md={{ span: 6, order: key % 2 === 0 ? 1 : 12 }}
              className={"text-left m-auto"}
              style={{ padding: "15px 0" }}
            >
              <Col md={{ span: 8, offset: 2 }}>
                <img
                  style={{ width: "64px", marginBottom: "0" }}
                  alt={
                    entry.node.relationships.field_icon_purple.field_media_image
                      .alt
                  }
                  src={
                    entry.node.relationships.field_icon_purple.relationships
                      .field_media_image.localFile.publicURL
                  }
                />
                <h3 style={{ marginBottom: "0.25em" }}>{entry.node.title}</h3>
                <p>{entry.node.field_summary}</p>
              </Col>
            </Col>
            <Col
              md={{ span: 6, order: key % 2 === 0 ? 12 : 1 }}
              style={{ padding: 0 }}
            >
              <GatsbyImage
                image={entry.node.relationships.field_image.relationships
                  .field_media_image.localFile.childImageSharp.gatsbyImageData}
                imgStyle={{ objectFit: "cover" }}
                alt={entry.node.relationships.field_image.field_media_image.alt} />
            </Col>
          </Row>
        );
      })}
    </div>
  );
}

export default props => (
  <StaticQuery
    query={graphql`{
  allNodeService(sort: {fields: created, order: DESC}) {
    edges {
      node {
        id
        created
        title
        field_summary
        relationships {
          field_icon_purple {
            field_media_image {
              alt
            }
            relationships {
              field_media_image {
                localFile {
                  publicURL
                }
              }
            }
          }
          field_image {
            field_media_image {
              alt
            }
            relationships {
              field_media_image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`}
    render={data => <ShowcaseGrid data={data} {...props} />}
  />
)
